// @vendors
const Immutable = require('immutable');
// @constants
const actionTypes = require('constants/RAConstants/actionTypes');
const {
    TIME_HORIZON_CHECK_NOT_PERFORMED,
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_VALID,
    TIME_HORIZON_CHECK_WARNING,
} = require('constants/RAConstants');
import { formatDateToYYYYMMDD, getDayStart, getDateWithOffset } from 'utilities/dateHelper/dateHelper';

const initialState = Immutable.fromJS({
    newHorizonTime: null,
    isFetching: false,
    success: false,
    error: false,
    errorMessage: null,
    warningIpModification: false,
    HTPI: null,
    status: TIME_HORIZON_CHECK_NOT_PERFORMED,
    originalMaxTypeOfProduct: 0,
    maxTypeOfProduct: 0,
});

const getNextYearPlusOneDayDate = () => {
    return getDateWithOffset(getDayStart(new Date()), { years: 1, days: 1 });
};

const validation = (response, state) => {
    if (!response.maxTypeOfProduct) {
        return {
            status: TIME_HORIZON_CHECK_ERROR,
            maxTypeOfProduct: state.get('maxTypeOfProduct'),
        };
    }

    //Modifica PI
    if (response.ipModification) {
        return {
            status: TIME_HORIZON_CHECK_ERROR,
            maxTypeOfProduct: state.get('maxTypeOfProduct'),
        };
    } // HTMaxOfProduct > HTPIMaxOfProduct & NO Modifica PI

    const originalMaxTypeOfProduct = state.get('originalMaxTypeOfProduct');
    const maxTypeOfProduct = state.get('maxTypeOfProduct');
    const newMaxTypeOfProduct = response.maxTypeOfProduct;

    if (maxTypeOfProduct > newMaxTypeOfProduct || originalMaxTypeOfProduct > newMaxTypeOfProduct) {
        return {
            status: TIME_HORIZON_CHECK_WARNING,
            maxTypeOfProduct: response.maxTypeOfProduct,
        };
    }

    //HTMaxOfProduct < = HTPIMaxOfProduct & NO Modifica PI
    return {
        status: TIME_HORIZON_CHECK_VALID,
        maxTypeOfProduct: response.maxTypeOfProduct,
    };
};

const RATimeHorizonCheck = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK:
            return initialState.merge({
                maxTypeOfProduct: state.get('originalMaxTypeOfProduct'),
                originalMaxTypeOfProduct: state.get('originalMaxTypeOfProduct'),
            });
        case actionTypes.RA_TIME_HORIZON_CHECK_SET_MAX_TYPE_OF_PRODUCTS:
            return initialState.merge({
                maxTypeOfProduct: action.newMaxTypeOfProduct,
                originalMaxTypeOfProduct: state.get('originalMaxTypeOfProduct'),
            });
        case actionTypes.RA_TIME_HORIZON_CHECK_SET_TIME:
            return initialState.merge({
                newHorizonTime: action.newHorizonTime,
                maxTypeOfProduct: state.get('maxTypeOfProduct'),
                originalMaxTypeOfProduct: state.get('originalMaxTypeOfProduct'),
            });
        case actionTypes.RA_TIME_HORIZON_CHECK_REQUEST:
            return initialState.merge({
                newHorizonTime: state.get('newHorizonTime'),
                maxTypeOfProduct: state.get('maxTypeOfProduct'),
                originalMaxTypeOfProduct: state.get('originalMaxTypeOfProduct'),
                isFetching: true,
            });
        case actionTypes.RA_TIME_HORIZON_CHECK_SUCCESS:
            return state.merge(validation(action.payload, state)).merge({
                ipModification: action.payload.ipModification,
                isFetching: false,
                success: true,
                error: false,
                HTPI: action.payload.HTPI,
            });
        case actionTypes.RA_TIME_HORIZON_CHECK_FAILURE:
            return state.merge({
                isFetching: false,
                success: false,
                error: true,
                errorMessage: action.payload,
                maxTypeOfProduct: state.get('maxTypeOfProduct'),
            });
        case actionTypes.RA_SUITABILITY_GET_TEST_RESULT_SUCCESS:
            const missingCheck = !state.get('success');

            return state.merge(
                missingCheck
                    ? {
                          maxTypeOfProduct: action.payload.results[0].maxTypeOfProduct || 0,
                          originalMaxTypeOfProduct: action.payload.results[0].maxTypeOfProduct || 0,
                      }
                    : {}
            );
        case actionTypes.RA_SIMULATION_REQUEST_SUCCESS:
            const horizonTime = formatDateToYYYYMMDD(action.payload.endDate ?? getNextYearPlusOneDayDate());

            return state.merge({
                newHorizonTime: horizonTime,
            });
        case actionTypes.RA_SIMULATION_REQUEST_FAILURE:
            return state.merge({
                newHorizonTime: formatDateToYYYYMMDD(getNextYearPlusOneDayDate()),
            });
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS:
            const endDate = action.payload.data.endDate ? new Date(action.payload.data.endDate) : new Date();

            return state.merge({
                newHorizonTime: formatDateToYYYYMMDD(endDate),
            });
        default:
            return state;
    }
};

module.exports = RATimeHorizonCheck;
